import { useCallback } from 'react'
import api from '../api/client'

interface CrossTokenResponse {
  token: string
  url: string
}

/**
 * Hook for generating cross-auth SSO URLs for NDB/eWinSpeed links.
 *
 * Usage:
 *   const { getCrossAuthUrl } = useCrossAuth()
 *   // In an onClick handler:
 *   const url = await getCrossAuthUrl('https://pigeon-ndb.com/results/')
 *   window.open(url, '_blank')
 */
export function useCrossAuth() {
  const getCrossAuthUrl = useCallback(async (targetUrl: string): Promise<string> => {
    try {
      const { data } = await api.get<CrossTokenResponse>('/auth/cross-token', {
        params: { redirect: targetUrl },
      })
      return data.url
    } catch {
      // If token generation fails, fall back to the direct URL
      return targetUrl
    }
  }, [])

  return { getCrossAuthUrl }
}
